<template>
    <div class="iframe_div" v-if="username != ''">
        <div class="iframe_div_title"></div>
        <div class="header_box" v-if="jichuObj != null">
            <div class="queryStr_show">
                网站信息：<font>{{queryStr}}</font>
            </div>
            <div class="company">
                <div class="name">{{jichuObj.corpName}}</div>
                <div class="go">
                    <a :href="'https://www.xcc.cn/queryContent/'+jichuObj.xccId+'.html'" target="_blank">
                        企业详情>
                    </a>
                </div>
            </div>

            <div class="query_content">
                <div class="tabs">
                    <span class="value1">企业</span>
                    <span class="value2">{{jichuObj.corpStatus}}</span>
                    <span class="value3">{{jichuObj.industry}}</span>
                </div>
                <div class="info">
                    <div class="info-list">
                        <span>法定代表人：<font>{{jichuObj.legal}}</font></span>
                        <span>成立日期：<font>{{jichuObj.sDate}}</font></span>
                    </div>
                    <div class="info-list">
                        <span>注册资本：<font>{{jichuObj.capital}}</font></span>
                    </div>
                    <div class="info-list">
                        <span>联系地址：<font>{{jichuObj.corpAddr}}</font></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="keep_box_div" v-if="jichuObj.keyWordInfoList != undefined &&jichuObj != null">
            <div class="keep_name">
                推广记录
                <div class="go" v-if="jichuObj.keyCount != 0">
                    <a :href="'https://xcxs.xcc.cn/pages/itemContent/itemContent?id='+jichuObj.keyId" target="_blank">
                        更多记录({{jichuObj.keyCount}})>
                    </a>
                </div>
            </div>
            <div class="query_content">
                <table border="0" class="tableClass_twe" cellspacing="" cellpadding="">
                <tr class="grey">
                    <td>关键词</td>
                    <td>推广平台</td>
                    <td>推广时间</td>
                </tr>
                <tr class="white" v-for="(item,index) in jichuObj.keyWordInfoList" :key="index">
                    <td>
                        {{item.clueKeyword}}
                    </td>
                    <td>
                        <span v-if="item.clueSpreadStage == 1">百度</span>
                        <span v-if="item.clueSpreadStage == 2">360</span>
                        <span v-if="item.clueSpreadStage == 3">搜狗</span>
                        <span v-if="item.clueSpreadStage == 4">神马</span>
                    </td>
                    <td>{{item.clueSpreadDate}}</td>
                </tr>
            </table>
            </div>
        </div>
        <div class="keep_box_div" v-if="phoneList.length != 0">
            <div class="keep_name">联系方式(<font class="blue">{{phoneList.length}}</font>)</div>
            <div class="query_content">
                <div class="info">
                    <div class="info-list" v-for="(item,index) in phoneList" :key="index">
                        <span>{{isPhone(item)}}：<font>{{item}}</font></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="keep_box_div">
            <div class="keep_name">网站备案信息</div>
            <div class="query_content">
                <div class="info">
                    <div class="info-list" v-if="jichuObj != null">
                        <span>网站名称：<font>{{jichuObj.icpInfoDTOS.webName}}</font></span>
                    </div>
                    <div class="info-list">
                        <span>网站主页：<font>{{jichuObj.icpInfoDTOS.webUrl}}</font></span>
                    </div>
                    <div class="info-list">
                        <span>备案时间：<font>{{jichuObj.icpInfoDTOS.webDate}}</font></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="iframe_div" v-else>
        <div class="iframe_div_title"></div>
        <div class="header_box" v-if="jichuObj != null">
            <div class="queryStr_show">
                网站信息：<font>{{queryStr}}</font>
            </div>
            <div class="company">
                <div class="name" v-if="window.location.hostname == 'localhost'">个人网站</div>
                <div class="name" v-else>{{jichuObj.corpName}}</div>
                <div class="go">
                    <a :href="'https://www.xcc.cn/queryContent/'+jichuObj.xccId+'.html'" target="_blank">
                        企业详情>
                    </a>
                </div>
            </div>

            <div class="query_content">
                <div class="tabs">
                    <span class="value1">企业</span>
                    <span class="value2">{{jichuObj.corpStatus}}</span>
                    <span class="value3">{{jichuObj.industry}}</span>
                </div>
                <div class="info">
                    <img class="img_class" src="https://zyprogram.xinchacha.com/plugin/mohu.png" alt="" srcset="">
                </div>
            </div>
        </div>

        <div class="keep_box_div" v-if="jichuObj != null">
            <div class="keep_name">
                推广记录
                <div class="go" v-if="jichuObj.keyCount != 0">
                    <a :href="'https://xcxs.xcc.cn/pages/itemContent/itemContent?id='+jichuObj.keyId" target="_blank">
                        更多记录>
                    </a>
                </div>
            </div>
            <div class="query_content">
                <img class="img_class" src="https://zyprogram.xinchacha.com/plugin/mohu.png" alt="" srcset="">
            </div>
        </div>

        <div class="keep_box_div" v-if="phoneList.length != 0">
            <div class="keep_name">联系方式(<font class="blue">{{phoneList.length}}</font>)</div>
            <div class="query_content">
                <img class="img_class" src="https://zyprogram.xinchacha.com/plugin/mohu.png" alt="" srcset="">
            </div>
        </div>

        
        <div class="keep_box_div">
            <div class="keep_name">网站备案信息</div>
            <div class="query_content">
                <img class="img_class" src="https://zyprogram.xinchacha.com/plugin/mohu.png" alt="" srcset="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            username:'',
            token:'',
            queryStr:'',
            quertType:1,
            jichuObj:null,
            phoneList:[]
        }
    },
    methods:{
        isPhone(str){
            var reg_tel = /^(1[0-9])\d{9}$/
            var cc = '';
            cc = reg_tel.test(str);
            if (cc == true) {
                cc = '手机'
            }else if (str.indexOf('@')>0) {
                cc = '邮箱'
            }else{
                cc = '座机'
            }
            return cc
        },
        getTimeString(){
            var timeString = new Date().getTime();
            return timeString;
        },
        init(){
            var _this = this;
		    var timeString = this.getTimeString();
            var headerObj = {
                'token': this.token,
			    'username':this.username,
			    'Content-Type': 'application/x-www-form-urlencoded',
			    'time':timeString
            }
            this.$axios({
                methods:'GET',
                url:this.$posh+'api/clue/corp',
                params:{
                    t:this.quertType,
                    k:this.queryStr
                },
                headers:headerObj
            }).then(res=>{
                var data = this.$Decrypt(res.data,res.config.headers.time);
                if (data.status == 200) {
                    _this.jichuObj = data.obj;
                    console.log(data.obj);
                    _this.getInit2();
                }
            })
        },
        getInit2(){
            var _this = this;
		    var timeString = this.getTimeString();
            var headerObj = {
                'token': this.token,
			    'username':this.username,
			    'Content-Type': 'application/x-www-form-urlencoded',
			    'time':timeString
            }
            this.$axios({
                methods:'GET',
                url:this.$posh+'api/clue/corp/phone/'+_this.jichuObj.xccId,
                headers:headerObj
            }).then(res=>{
                var data = this.$Decrypt(res.data,res.config.headers.time);
                if (data.status == 200){
                    console.log(data)
                    _this.phoneList = data.obj;
                }
            })
        },
        
    },
    mounted(){
        var _this = this;
        this.queryStr = this.$route.query.content;
        this.quertType = this.$route.query.type;
        console.log(this.queryStr);
        window.parent.postMessage({
            funName:'getStorage'
        },'*')
        window.addEventListener('message', function(e) {
            var data = e.data;
            console.log(data)
            if (data.username != undefined) {
                _this.username = data.username;
                _this.token = data.token;
                _this.init();
            }
        },false);
    }
}
</script>
<style lang="scss" scoped>
.iframe_div{
    width: 400px;
    height: auto;
    box-sizing: border-box;
}
.blue{
    font-size: 13px;
    font-weight: 700;
    color: #3385ff;
}

.img_class{
    width: 100%;
    height: auto;
    display: block;
}

.iframe_div_title{
    width: 100%;
    height: 57px;
    background-color: #3581FE;
    background-image: url('https://zyprogram.xinchacha.com/plugin/logo.png');
    background-repeat: no-repeat;
    background-size: auto 47px;
    background-position: 50% 50%;
}
.header_box{
    width: 92%;
    height: auto;
    margin: 0 auto 8px;
    box-sizing: border-box;
    border-bottom: 1px solid #efefef;
    >div.queryStr_show{
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;
        font-stretch: normal;
        letter-spacing: 0;
        color: #666;
        border-bottom: 1px solid #efefef;
        cursor: default;
        >font{
            color: #2169ff;
        }
    }
    >div.company{
        width: 100%;
        height: 24px;
        display: flex;
        margin-top: 4px;
        margin-bottom: 7px;
        line-height: 24px;
        >div.name{
            flex: 1;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            letter-spacing: 0;
            color: #2169ff;
            padding-right: 10px;
        }
        >div.go{
            font-size: 12px;
            font-weight: 400;
            font-stretch: normal;
            letter-spacing: 0;
            cursor: pointer;
            >a{
                color: #2169ff;
                text-decoration: none;
            }
        }
    }
    >div.query_content{
        width: 100%;
        height: auto;
        >div.tabs{
            width: 100%;
            height: auto;
            margin-bottom: 10px;
            cursor: default;
            >span{
                font-size: 12px;
                font-weight: 400;
                font-stretch: normal;
                letter-spacing: 0;
                margin-right: 7px;
                border-radius: 20px;
                line-height: 20px;
                padding: 0 10px;
            }
            >span.value1{
                color: #ec9662;
                background: #fff2e4;
            }
            >span.value2{
                color: #438fff;
                background: #e6f0ff;
            }
            >span.value3{
                color: #00ae64;
                background: #c8ffe8;
            }
        }
        >div.info{
            width: 100%;
            height: auto;
            margin-bottom: 10px;
            cursor: default;
            >div.info-list{
                display: flex;
                font-size: 12px;
                >span{
                    flex: 1;
                    color: #999;
                    line-height: 1.6em;
                    >font{
                        color: #333;
                    }
                }
            }
        }
    }
}

.keep_box_div{
    width: 92%;
    height: auto;
    margin: 0 auto 8px;
    box-sizing: border-box;
    padding-bottom: 8px;
    border-bottom: 1px solid #efefef;
    >div.keep_name{
        width: 100%;
        height: 24px;
        line-height: 24px;
        margin-bottom: 7px;
        flex: 1;
        font-size: 13px;
        font-weight: 700;
        font-stretch: normal;
        letter-spacing: 0;
        color: #444;
        >div.go{
            font-size: 12px;
            font-weight: 400;
            font-stretch: normal;
            letter-spacing: 0;
            cursor: pointer;
            float: right;
            >a{
                color: #2169ff;
                text-decoration: none;
            }
        }
    }
    >div.query_content{
        width: 100%;
        height: auto;
        cursor: default;
        >div.info{
            width: 100%;
            height: auto;
            margin-bottom: 10px;
            cursor: default;
            >div.info-list{
                display: flex;
                font-size: 12px;
                >span{
                    flex: 1;
                    color: #999;
                    line-height: 1.6em;
                    >font{
                        color: #333;
                    }
                }
            }
        }
        >table.tableClass_twe{
            width: 100%;
            height: auto;
            cursor: default;
            background-color: #efefef;
            tr.grey{
                height: 20px;
                line-height: 20px;
                background-color: #F5F7FA;  
                color: #333333;
                font-size: 12px;
                text-align: center;
            }
            tr.white{
                height: 20px;
                line-height: 20px;
                background-color: #fff; 
                color: #333333;
                font-size: 12px;
                text-align: center;
                a{
                    color: #333333;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/iframeDemo.vue